angular.module('SpidApp')

.factory('Scale',
        ['$http', 'SPID_CONFIG', '$q',
function ($http,   SPID_CONFIG,   $q) {
    var CONFIG = SPID_CONFIG.devices.scale

    var HOST = CONFIG.host
    var PORT = CONFIG.port
    
    var IS_MOCKED = CONFIG.isMocked

    var Scale = {
        _getHost: function () {
            return HOST + ':' + PORT
        },
        getStatus: (IS_MOCKED ? function () {
            return $q(function (resolve) {
                resolve()
            })
        } : function () {
            return $http.get(this._getHost() + '/scale').then(function (response) {
                return $q(function (resolve, reject) {
                    if (response.data.code === 0) {
                        resolve(response.data)
                    }

                    reject(response.data)
                })
            })
        }),
        getWeight: function () {
            return $http.get(this._getHost() + '/scale/weight').then(function (response) {
                /* response.data looks like this when everything's alright:
                {
                    code: 0,
                    value: {
                        Valeur: 150
                    }
                } */

                return $q(function (resolve, reject) {
                    if (response.data.code === 0) {
                        console.error(response)
                        resolve(response.data)
                    }

                    reject(response.data)
                })
            })
        }
    }

    return Scale
}])
